import type { PropsWithChildren } from "react";
import { createContext } from "react";

interface Props {
  onAddMetricExtensions: (metricIds: string[], metricName: string) => void;
}

const PortfolioMonitoringInputTableContext = createContext<Props | undefined>(undefined);

export const PortfolioMonitoringInputTableContextProvider = ({
  children,
  ...contextValue
}: PropsWithChildren<Props>) => (
  <PortfolioMonitoringInputTableContext value={contextValue}>{children}</PortfolioMonitoringInputTableContext>
);

export default PortfolioMonitoringInputTableContext;
